module.exports = __webpack_public_path__ + "img/team-oldenburgoutlaws@2x.4149b39a.jpg";